import { z } from 'zod';

export const minimalArtistSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export type MinimalArtist = z.infer<typeof minimalArtistSchema>;
